import {Pipe, PipeTransform} from '@angular/core';
import {UserModel} from '../models/user.model';

@Pipe({
  name: 'lbaUserFilterPipe',
})
export class UserFilterPipe implements PipeTransform {

  transform(users: Array<UserModel>, searchStr: string): any {
    searchStr = searchStr.toString().toLowerCase();
    const filteredUsers: Array<UserModel> = [];
    if (searchStr.length === 0) {
      return users;
    }
    for (const user of users){
      if (
        user.username.toLowerCase().indexOf(searchStr) !== -1 ||
        user.userId.toString().indexOf(searchStr) !== -1
      ) {
        filteredUsers.push(user);
      }
    }
    return filteredUsers;
  }

}
